<span class="sh-icon-label" [title]="tooltip">
  @if (iconPosition==='left') {
    <ng-container *ngTemplateOutlet="left"></ng-container>
  } @else {
    {{ label }}
    @if (icon) {
      <svg sh-icon [name]="icon" [size]="iconSize" aria-hidden="true" class="sh-icon-label__icon" [class.-sh-superscript]="iconSuperscript"></svg>
    }
  }
</span>

<ng-template #left>
  @if (icon) {
    <svg sh-icon [name]="icon" [size]="iconSize" aria-hidden="true" class="sh-icon-label__icon" [class.-sh-superscript]="iconSuperscript"></svg>
  }
  {{ label }}
</ng-template>

